import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import API from "../api/api";
import Navbar from "../components/Navbar";
import { errorAlert } from "../utils/alert";


const Verify = () => {
  const { regId } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
// When the URL is /verify/escort/:playerId/:eventId
const { type, id, eventId } = useParams();

useEffect(() => {
const load = async () => {
    try {
    let url = "";
    if (type === "escort") url = `/verify/escort/${id}/${eventId}`;
    else url = `/verify/${type}/${id}`;

    const res = await API.get(url);
    setData(res.data);
    } catch {
    setError("Invalid or unverified record.");
    } finally {
    setLoading(false);
    }
};
load();
}, [type, id, eventId]);

  useEffect(() => {
    if (!error) return;
    errorAlert("Verification failed", error);
  }, [error]);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await API.get(`/verify/player/${regId}`);
        setData(res.data);
      } catch (err) {
        setError("Invalid or unverified registration.");
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [regId]);

  return (
    <>
      <Navbar />
      <div className="flex flex-col items-center mt-12 sm:mt-20 text-center px-3 mobile-page-pad">
        {loading && <p className="text-blue-600">Verifying...</p>}
        {error && <p className="text-red-600 font-medium">{error}</p>}
        {data && (
          <div className="bg-white shadow-md rounded-lg p-4 sm:p-6 w-full max-w-md border">
            <h2 className="text-xl sm:text-2xl text-green-700 font-bold mb-3">✅ Verified Registration</h2>
            <p className="font-semibold text-gray-700">{data.player_name}</p>
            <p className="text-gray-600">{data.sport_name}</p>
            <p className="text-gray-600">Event: {data.event_title}</p>
            <p className="text-gray-500">Status: {data.status}</p>
            <p className="text-sm text-gray-400 mt-2">
              Registration ID: {data.registration_id}
            </p>
          </div>
        )}
      </div>
    </>
  );
};

export default Verify;
